import React, { useState, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import AuthContext from "../../Context/AuthContext";
import axios from "axios";

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const history = useHistory();
  const { loggedIn, setLoggedIn, getLoggedIn, setUserData } =
    useContext(AuthContext);

  // 🔹 Eğer zaten giriş yapılmışsa, anasayfaya yönlendir
  useEffect(() => {
    if (loggedIn) {
      history.push("/homepage");
    }
  }, [loggedIn, history]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!username.trim() || !password) {
      setError("Kullanıcı adı ve şifre gereklidir.");
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post("https://opt-api.vercel.app/Login", {
        username: username.trim(),
        password,
      });

      const { token, user } = res.data || {};
      if (token) {
        localStorage.setItem("auth-token", token);
        localStorage.setItem("token", token);

        // AuthContext'i senkronize et - bu userData'ı doğru şekilde set eder
        await getLoggedIn();

        // Login sayfasından çık
        history.push("/homepage");
      } else {
        setError("Sunucudan geçersiz cevap alındı.");
      }
    } catch (err) {
      const serverMsg =
        err?.response?.data?.hata || err?.response?.data?.message;
      setError(serverMsg || "Giriş sırasında bir hata oluştu.");
      console.error("Login error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-lg p-8">
        <div className="flex flex-col items-center mb-6">
          <div className="bg-indigo-600 text-white rounded-full p-3 mb-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 11c1.657 0 3-1.343 3-3V6a3 3 0 00-6 0v2c0 1.657 1.343 3 3 3z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 11h14v8a2 2 0 01-2 2H7a2 2 0 01-2-2v-8z"
              />
            </svg>
          </div>
          <h2 className="text-2xl font-semibold text-gray-800">
            Outdoor Planning Tool
          </h2>
          <p className="text-sm text-gray-500 mt-1">
            Kullanıcı adı ve şifrenizle devam edin
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Kullanıcı Adı
            </label>
            <input
              type="text"
              required
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-300"
              placeholder="Kullanıcı adı"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Şifre
            </label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-300 pr-12"
                placeholder="Şifreniz"
              />
              <button
                type="button"
                onClick={() => setShowPassword((s) => !s)}
                className="absolute right-2 top-1/2 -translate-y-1/2 text-sm text-indigo-600 hover:text-indigo-800"
                aria-label="Toggle password visibility"
              >
                {showPassword ? "Gizle" : "Göster"}
              </button>
            </div>
          </div>

          {error && <div className="text-red-600 text-sm">{error}</div>}

          <button
            type="submit"
            className="w-full py-2 bg-indigo-600 text-white rounded-lg font-medium hover:bg-indigo-700 disabled:opacity-60"
            disabled={loading}
          >
            {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
          </button>
        </form>
      </div>
    </div>
  );
}
